import React from 'react';

const Citation = () => {
    return (
        <section className="citation">
            <div className="citation-text">
                <p>
                    "Pour avoir ce que vous n'avez jamais eu,<br></br> il faudra faire ce que vous n'avez jamais fait."
                </p>
            </div>
        </section>
    );
};

export default Citation;
